import React from 'react'
import { useTheme } from '@/components/ThemeProvider'

const SplitLayout = ({ children }) => {
  const { resolvedTheme } = useTheme()

  const childrenArray = React.Children.toArray(children)
  const mainContent = childrenArray.filter(child => child.type !== SplitLayout.SidePanel)
  const sidePanel = childrenArray.find(child => child.type === SplitLayout.SidePanel)

  return (
    <div className='bg-background h-full w-full overflow-auto'>
      <div className='grid grid-cols-1 md:grid-cols-2 h-full'>
        <div className='flex flex-col items-center p-5 md:p-5'>
          <div className='w-full self-start mb-5'>
            <Choose>
              <When condition={resolvedTheme === 'dark'}>
                <img className='h-12 w-auto' src='/logo.svg' alt='Mindjoy logo' />
              </When>
              <Otherwise>
                <img className='h-12 w-auto' src='/mindjoy-logo.svg' alt='Mindjoy logo' />
              </Otherwise>
            </Choose>
          </div>

          <div className='flex flex-col md:justify-center w-full h-full md:max-w-md'>
            {mainContent}
          </div>
        </div>

        <div className='bg-[#8C52FF] dark:bg-[#4A148C] h-full hidden md:block'>
          {sidePanel}
        </div>
      </div>
    </div>
  )
}

SplitLayout.SidePanel = ({ children }) => {
  return <>{children}</>
}

export default SplitLayout
